export default __webpack_public_path__ + "static/media/iconGmail.bbfe19dc.svg";